export interface RegContact {
  id: string;
  name: string;
  role: string;
  email: string;
  phone: string;
  is_primary: boolean;
}

export interface RegServiceLocation {
  id: string;
  city: string;
  postal_code: string;
  radius_km: number;
}

export interface RegistrationForm {
  company_name: string;
  company_type: string;
  legal_name: string;
  contact_name: string;
  contact_role: string;
  contact_email: string;
  phone: string;
  website: string;
  invoice_email: string;
  address_line1: string;
  postal_code: string;
  city: string;
  country: string;
  vat_id: string;
  region: string;
  service_regions: string[];
  service_locations: RegServiceLocation[];
  remote_supported: boolean;
  categories: string[];
  selectedStackTags: string[];
  sla_tier: string;
  sla_response_hours: number;
  weekly_lead_limit: number;
  contacts: RegContact[];
}

export const INITIAL_REG_FORM: RegistrationForm = {
  company_name: "",
  company_type: "",
  legal_name: "",
  contact_name: "",
  contact_role: "",
  contact_email: "",
  phone: "",
  website: "",
  invoice_email: "",
  address_line1: "",
  postal_code: "",
  city: "",
  country: "DE",
  vat_id: "",
  region: "",
  service_regions: [],
  service_locations: [],
  remote_supported: false,
  categories: [],
  selectedStackTags: [],
  sla_tier: "NBD",
  sla_response_hours: 24,
  weekly_lead_limit: 5,
  contacts: [],
};

export type RegistrationTab = "stammdaten" | "kontakte" | "service";

export const REG_TABS: { id: RegistrationTab; label: string }[] = [
  { id: "stammdaten", label: "Stamm- & Adressdaten" },
  { id: "kontakte", label: "Kontaktdaten" },
  { id: "service", label: "Service & Matching" },
];

export const REGIONS = [
  "Baden-Württemberg", "Bayern", "Berlin", "Brandenburg", "Bremen", "Hamburg",
  "Hessen", "Mecklenburg-Vorpommern", "Niedersachsen", "Nordrhein-Westfalen",
  "Rheinland-Pfalz", "Saarland", "Sachsen", "Sachsen-Anhalt",
  "Schleswig-Holstein", "Thüringen", "DACH-weit",
];

export const SERVICE_CATEGORIES = [
  { value: "managed_service", label: "Managed Services" },
  { value: "project", label: "IT-Projekt" },
  { value: "security", label: "Security & Compliance" },
  { value: "cloud", label: "Cloud & Infrastruktur" },
  { value: "support", label: "IT-Support" },
];
